import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSteamTrap = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52.48,
	height: 52.48,
	viewBox: "0 0 52.48 52.48",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 25,
		cy: 25,
		rx: 25,
		ry: 25,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 42.7 7.3 A 25.0 25.0 0.0 1 1 7.3 42.7 Z",
		fill: "#000000",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgSteamTrap;
